import configs from 'configs';
import { Token } from '@kambria/kambria-contract';

const KAMBRIA_WALLET_ERROR = 'Your wallet is not connected. Please click "Connect" button first, choose Ethereum Network and ensure your KAT balance is displayed correctly at the top of this screen.';

/**
 * Documents
 * @default defaultData = {
 *  txId: (string) transaction hash
 *  allowance: (string)
 *  balanceOf: (string)
 * }
 */

const defaultState = {}

/**
 * Transfer
 */
export const ETHEREUM_TRANSFER_TOKEN = 'ETHEREUM_TRANSFER_TOKEN';
export const ETHEREUM_TRANSFER_TOKEN_OK = 'ETHEREUM_TRANSFER_TOKEN_OK';
export const ETHEREUM_TRANSFER_TOKEN_FAIL = 'ETHEREUM_TRANSFER_TOKEN_FAIL';

function _transferToken(to, amount, callback) {
  try {
    var provider = window.kambriaWallet.provider;
    var web3 = provider.web3;
  } catch (er) {
    return callback(KAMBRIA_WALLET_ERROR, null);
  }

  var token = new Token(configs.eth.TOKEN.ADDRESS, web3);
  token.transfer(to, amount).then(txId => {
    return callback(null, txId);
  }).catch(er => {
    return callback(er, null);
  });
}

export const ethTransferToken = (to, amount) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      _transferToken(to, amount, (er, re) => {
        dispatch({ type: ETHEREUM_TRANSFER_TOKEN });
        if (er) {
          dispatch({ type: ETHEREUM_TRANSFER_TOKEN_FAIL, reason: er });
          return reject(er);
        }
        dispatch({ type: ETHEREUM_TRANSFER_TOKEN_OK, reason: null, data: { txId: re } });
        return resolve(re);
      });
    });
  }
}

/**
 * Transfer From
 */
export const ETHEREUM_TRANSFER_TOKEN_FROM = 'ETHEREUM_TRANSFER_TOKEN_FROM';
export const ETHEREUM_TRANSFER_TOKEN_FROM_OK = 'ETHEREUM_TRANSFER_TOKEN_FROM_OK';
export const ETHEREUM_TRANSFER_TOKEN_FROM_FAIL = 'ETHEREUM_TRANSFER_TOKEN_FROM_FAIL';

function _transferTokenFrom(from, to, amount, callback) {
  try {
    var provider = window.kambriaWallet.provider;
    var web3 = provider.web3;
  } catch (er) {
    return callback(KAMBRIA_WALLET_ERROR, null);
  }

  var token = new Token(configs.eth.TOKEN.ADDRESS, web3);
  token.transferFrom(from, to, amount).then(txId => {
    return callback(null, txId);
  }).catch(er => {
    return callback(er, null);
  });
}

export const ethTransferTokenFrom = (from, to, amount) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      _transferTokenFrom(from, to, amount, (er, re) => {
        dispatch({ type: ETHEREUM_TRANSFER_TOKEN_FROM });
        if (er) {
          dispatch({ type: ETHEREUM_TRANSFER_TOKEN_FROM_FAIL, reason: er });
          return reject(er);
        }
        dispatch({ type: ETHEREUM_TRANSFER_TOKEN_FROM_OK, reason: null, data: { txId: re } });
        return resolve(re);
      });
    });
  }
}

/**
 * Approve
 */
export const ETHEREUM_APPROVE_TOKEN = 'ETHEREUM_APPROVE_TOKEN';
export const ETHEREUM_APPROVE_TOKEN_OK = 'ETHEREUM_APPROVE_TOKEN_OK';
export const ETHEREUM_APPROVE_TOKEN_FAIL = 'ETHEREUM_APPROVE_TOKEN_FAIL';

function _approveToken(to, amount, callback) {
  try {
    var provider = window.kambriaWallet.provider;
    var web3 = provider.web3;
  } catch (er) {
    return callback(KAMBRIA_WALLET_ERROR, null);
  }

  var token = new Token(configs.eth.TOKEN.ADDRESS, web3);
  token.approve(to, amount).then(txId => {
    return callback(null, txId);
  }).catch(er => {
    return callback(er, null);
  });
}

export const ethApproveToken = (to, amount) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      _approveToken(to, amount, (er, re) => {
        dispatch({ type: ETHEREUM_APPROVE_TOKEN });
        if (er) {
          dispatch({ type: ETHEREUM_APPROVE_TOKEN_FAIL, reason: er });
          return reject(er);
        }
        dispatch({ type: ETHEREUM_APPROVE_TOKEN_OK, reason: null, data: { txId: re } });
        return resolve(re);
      });
    });
  }
}

/**
 * Allowance
 */
export const ETHEREUM_ALLOWANCE = 'ETHEREUM_ALLOWANCE';
export const ETHEREUM_ALLOWANCE_OK = 'ETHEREUM_ALLOWANCE_OK';
export const ETHEREUM_ALLOWANCE_FAIL = 'ETHEREUM_ALLOWANCE_FAIL';

function _allowance(from, to, callback) {
  try {
    var provider = window.kambriaWallet.provider;
    var web3 = provider.web3;
  } catch (er) {
    return callback(KAMBRIA_WALLET_ERROR, null);
  }

  var token = new Token(configs.eth.TOKEN.ADDRESS, web3);
  token.allowance(from, to).then(re => {
    return callback(null, re);
  }).catch(er => {
    return callback(er, null);
  });
}

export const ethAllowance = (from, to) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      _allowance(from, to, (er, re) => {
        dispatch({ type: ETHEREUM_ALLOWANCE });
        if (er) {
          dispatch({ type: ETHEREUM_ALLOWANCE_FAIL, reason: er });
          return reject(er);
        }
        dispatch({ type: ETHEREUM_ALLOWANCE_OK, reason: null, data: { allowance: re } });
        return resolve(re);
      });
    });
  }
}

/**
 * Balance Of
 */
export const ETHEREUM_BALANCE_OF = 'ETHEREUM_BALANCE_OF';
export const ETHEREUM_BALANCE_OF_OK = 'ETHEREUM_BALANCE_OF_OK';
export const ETHEREUM_BALANCE_OF_FAIL = 'ETHEREUM_BALANCE_OF_FAIL';

function _balanceOf(address, callback) {
  try {
    var provider = window.kambriaWallet.provider;
    var web3 = provider.web3;
  } catch (er) {
    return callback(KAMBRIA_WALLET_ERROR, null);
  }

  var token = new Token(configs.eth.TOKEN.ADDRESS, web3);
  token.balanceOf(address).then(re => {
    return callback(null, re);
  }).catch(er => {
    return callback(er, null);
  });
}

export const ethBalanceOf = (address) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      _balanceOf(address, (er, re) => {
        dispatch({ type: ETHEREUM_BALANCE_OF });
        if (er) {
          dispatch({ type: ETHEREUM_BALANCE_OF_FAIL, reason: er });
          return reject(er);
        }
        dispatch({ type: ETHEREUM_BALANCE_OF_OK, reason: null, data: { balanceOf: re } });
        return resolve(re);
      });
    });
  }
}

/**
 * Reducder
 */
export default (state = defaultState, action) => {
  switch (action.type) {
    case ETHEREUM_TRANSFER_TOKEN_OK:
      return { ...state, ...action.data };
    case ETHEREUM_TRANSFER_TOKEN_FAIL:
      return { ...state, ...action.data };
    case ETHEREUM_TRANSFER_TOKEN_FROM_OK:
      return { ...state, ...action.data };
    case ETHEREUM_TRANSFER_TOKEN_FROM_FAIL:
      return { ...state, ...action.data };
    case ETHEREUM_APPROVE_TOKEN_OK:
      return { ...state, ...action.data };
    case ETHEREUM_APPROVE_TOKEN_FAIL:
      return { ...state, ...action.data };
    case ETHEREUM_ALLOWANCE_OK:
      return { ...state, ...action.data };
    case ETHEREUM_ALLOWANCE_FAIL:
      return { ...state, ...action.data };
    case ETHEREUM_BALANCE_OF_OK:
      return { ...state, ...action.data };
    case ETHEREUM_BALANCE_OF_FAIL:
      return { ...state, ...action.data };
    default:
      return state;
  }
}
